import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import notificationsBar from "@/components/notifications-bar/notifications-bar.js";
import responsive from "@/utils/responsive/responsive.js";
import axios from "axios";
import VueGtag from "vue-gtag";

import { i18n } from "@/utils/helpers/translation/i18n.js";

// Import Custom Prototypes
import Prototypes from "./prototypes.js";

// Import CSS
import "./assets/sass/app.scss";


// axios.defaults.withCredentials = true;

Vue.config.productionTip = false;

Vue.use(VueMeta);

Vue.use(responsive);
Vue.use(notificationsBar);

// Google Analytics

if (process.env.NODE_ENV === "production") {
    Vue.use(VueGtag, {
        config: { id: "G-JR6R9CPGQY" }
    });
}

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
